import React, { useEffect } from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { Device } from '@capacitor/device';
import axios from 'axios';

import { FCM } from '@capacitor-community/fcm';


// Bage helper
import {
  appHelper,
  // Bage helper
  appBage,
} from 'appCapacitor/helpers';

import { default as appPushNotifications } from 'appCapacitor/helpers/pushNotifications';

import {
  useGetLocalUser,
  useCheckPushNotificationParameters,
} from 'engine/Contexts/User.context';

const apiURL = appHelper.getBaseApiUrl();
axios.defaults.baseURL = apiURL;

function PushNotificationsListener () {
  const history = useHistory();
  const checkParentChild = useCheckPushNotificationParameters();

  useEffect(() => {

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError', error => {
      console.debug(error);
    });

    //PushNotifications.removeAllDeliveredNotifications();

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener(
      'pushNotificationReceived',
      notification => {
        PushNotifications.getDeliveredNotifications().then(result => {
          const notifications = result?.notifications;
          appBage.setBadgeCount(notifications?.length);
          /*  console.debug(
            'Push getDeliveredNotifications',
            JSON.stringify(notifications),
          ); */
        });
         // console.debug('Push received: pushNotificationReceived', JSON.stringify(notification));
      },
    );

    /*
      * Method called when tapping on a notification
      */
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      notification => {
       //  console.debug('pushed', JSON.stringify(notification));
       //  console.debug('Push action performed: hehe');

      /*    PushNotifications.getDeliveredNotifications().then(result => {
          const notifications = result?.notifications;
          appBage.setBadgeCount(notifications?.length);
            console.debug(
            'Push getDeliveredNotifications',
            JSON.stringify(notifications),
          ); 
        });  */

        const bageAmount = appBage.getBadgeCount();
      //   console.debug('GET bageAmount: ', JSON.stringify(bageAmount));

        let link = notification.notification.data.url;
        const search = link.split('?').pop();
        const params = queryString.parse(search);
        const slug = link.split('push-notification').pop();
       // console.debug('slug', slug);

        if (slug) {
          const notifParams = Object.assign(params, { notifAmount: bageAmount });
          /*  console.debug('redirect to detail', JSON.stringify(notifParams));*/
          console.debug('redirect to detail params', JSON.stringify(params));
          checkParentChild(params);
          if (!!params?.responseID && params?.childId) {
            history.push(`/communications/${params?.responseID}?childId=${params?.childId}&IDComm=${params?.responseID}&needRefresh=true`);
          } else if (!!params?.communicationId && !params?.childId) {
            history.push(`/communications/${params?.communicationId}?IDComm=${params?.communicationId}&needRefresh=true`);
          } else if (!!params?.msgInDiscussion) {
            history.push(`/communications/?needRefresh=true`);
          } else {
            history.push(slug);
          }
          
          appBage.decreaseBadge();
        } else {
          // console.debug('redirect to notifications');
          history.push('/notifications');
          appBage.decreaseBadge();
        }
        
      },
    );
  }, []);

  return <></>;
};

export default PushNotificationsListener;